module.exports = __webpack_public_path__ + "img/tabar_withdraw1.fb0c9df5.png";